const formatDate = (date: string): string => {
  const value = new Date(date);

  if (Number.isNaN(value.getTime())) return date;

  return new Intl.DateTimeFormat('en', {
    day: 'numeric',
    month: 'short',
    year: 'numeric',
  }).format(value);
};

export { formatDate };
